// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8a03343257aabd5715e3","655":"b29f5843983a5e033ea0"}[chunkId] + ".js";
};